<template>
	<div class="search-results-wrapper">
		<section class="hero--search hero--simple hero bg-primary">
			<div class="container">
				<div class="row">
					<div class="breadcrumb">
						<ul class="breadcrumb-wrapper">
							<li>
								<a href="/">Home</a>
							</li>
							<li>Search Results</li>
						</ul>
					</div>
				</div>

				<div class="row">
					<div class="hero-content col-12">
						<div class="hero-txt">
							<h1 class="hero-heading">Search Results for "{{ specification.Query }}"</h1>
							<div class="hero-search">
								<input @keydown.enter="onEnterKey" type="text" v-model="query" class="hero-input"/>
								<button class="hero-btn fas fa-search" @click="updateQuery"></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="search-list-items section js-listing-top">
			<div v-if="pagination.total> 0">
				<div class="container">
					<div class="row">
						<div class="search-filter-container col-12 col-lg-3">
							<div class="search-filter">
								<h3 class="search-filter-heading">Filter Results</h3>
								<div class="search-filter-selected js-search-filter-dropdown" v-on:click="toggleDropdown($event)">{{ selectedFilter }} <span>{{ selectedCount | formatCount }}</span></div>
								<ul class="search-filter-items js-search-filter-list">
									<!--<li class="search-filter-item" @click="clearFilter">All <span>{{ pagination.total | formatCount }}</span></li>-->
									<li v-for="(facet, index) in facets" @click="updateFilter(facet.Value, index, $event)" class="search-filter-item" :class="{ 'selected': (facet.Value == selectedFilter) }">{{ facet.Value }} <span>{{ facet.Count | formatCount }}</span></li>
								</ul>
							</div>
						</div>
						<div class="search-list-item-wrapper col-12 col-lg-9">
							<search-item v-for="(item, index) in listing" v-bind:item="item" v-bind:specification="specification" v-bind:key="item.DetailID"></search-item>
						</div>
						<div class="col-12 offset-lg-3 col-lg-9">
							<pagination :totalResults="pagination.total"></pagination>
						</div>
					</div>
				</div>
			</div>

			<div v-if="pagination.total == 0">
				<div class="container">
					<div class="row">
						<div class="search-list-no-results col-12 col-lg-8 offset-lg-2">
							<h2>Sorry, there aren’t any pages matching your search.</h2>
							<p>Try checking your spelling or using a different term.</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/pagination-search-results';
	import SearchItem from '../components/search/search-item';

	export default {
		props: ['filterid', 'filtertype', 'result', 'resource'],
		data: function () {
			return {
				filters: [],
				selectedFilter: '',
				selectedIndex: 0,
				selectedCount: 0,
				query: ''
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			facets: state => state.listing.facets,
			specification: state => state.listing.specification,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
			'search-item': SearchItem,
		},
		mounted: function () {
			let vm = this;

			vm.query = vm.result.Specification.Query;

			// take props and send to vuex store
			vm.setInitData(this.result);
			vm.setResource(this.resource);

			if ( vm.facets.length ) {
				if (vm.specification.Filter === null ) {
					$('.search-filter-item').first().addClass('selected');
					vm.selectedFilter = 'All';
					vm.selectedCount =  vm.pagination.total;
				}
				else {
					vm.selectedFilter = vm.specification.Filter;
				}
			}

			// after filter comes back, scroll to the top
			let scroll = new SmoothScroll();
			let options = {
				header: '[data-scroll-header]',
                speed: 500,
				offset: 0
			};

			// after any api calls, scroll to the top of the list
			vm.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					let anchor = document.querySelector('#' + vm.filterid);
					let header = document.getElementsByClassName('header')[0];
					
					scroll.animateScroll(anchor, null, options);

					setTimeout(() => {
						scroll.cancelScroll();
					}, 2000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			vm.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					vm.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			updateFilter(value, index, event) {
				if(value === 'All') {
					this.clearFilter(event);
				}else {
					let vm = this;

					$('.search-filter-item').removeClass('selected');

					vm.selectedFilter = vm.facets[index].Value;
					vm.selectedCount = vm.facets[index].Count;
					vm.selectedIndex = index;

					$('.js-search-filter-dropdown').toggleClass('open');
					$('.js-search-filter-list').toggleClass('open');

					$(event.currentTarget).addClass('selected');

					vm.updateSpecification({ key: 'Filter', value: encodeURIComponent( vm.facets[index].Value ) });
				}
			},
			clearFilter(event) {
				let vm = this;

				$('.search-filter-item').removeClass('selected');
				$('.search-filter-item').first().addClass('selected');
				vm.selectedFilter = 'All';
				vm.selectedCount =  vm.pagination.total;
				vm.selectedIndex = 0;
				vm.updateSpecification({ key: 'Filter', value: '' });
			},
			onEnterKey() {
				this.updateQuery();
			},
			updateQuery() {
				let vm = this;

				vm.updateSpecification({ key: 'Query', value: encodeURIComponent( vm.query ) } );
			},
			toggleDropdown(event) {
				let vm = this;

				event.stopPropagation();

				$('.js-search-filter-dropdown').toggleClass('open');
				$('.js-search-filter-list').toggleClass('open');
			}
        },
		filters: {
			formatCount(value) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			}
		},
    }
</script>